import { Redirect, Route, Switch } from 'react-router-dom';

import NotFound from 'pages/NotFound/NotFound';
import { OrganizationsPage } from 'pages/Organizations';
import { UsersPage } from 'pages/Users';
import { UserDiagnosticsPage } from 'pages/UserDiagnostics';
import TrackingDiagnosticsPage from 'pages/TrackingDiagnostics';
import DiagnosticsPackagesPage from 'pages/DiagnosticsPackages';

export const DefaultRoutes = {
  OrganizationsPage: '/',
  UsersPage: '/users',
  UserDiagnosticsPage: '/issue-reports',
  TrackingDiagnosticsPage: '/tracking-diagnostics',
  DiagnosticsPackagesPage: '/diagnostics-packages',
} as const;

export const routes = (
  <Switch>
    <Route exact path={`${DefaultRoutes.OrganizationsPage}`} component={OrganizationsPage} />
    <Route exact path={`${DefaultRoutes.UsersPage}/:organizationId`} component={UsersPage} />
    <Route exact path={`${DefaultRoutes.UserDiagnosticsPage}`} component={UserDiagnosticsPage} />
    <Route exact path={`${DefaultRoutes.TrackingDiagnosticsPage}`} component={TrackingDiagnosticsPage} />
    <Route exact path={`${DefaultRoutes.DiagnosticsPackagesPage}`} component={DiagnosticsPackagesPage} />
    <Redirect exact from={'/organization_reassigned'} to={DefaultRoutes.OrganizationsPage} />
    <Route component={NotFound} />
  </Switch>
);
